module.exports = __webpack_public_path__ + "img/diagnose-bg.db721501.png";